import { render, staticRenderFns } from "./BookLayout.vue?vue&type=template&id=e71cf960&scoped=true&"
import script from "./BookLayout.vue?vue&type=script&lang=js&"
export * from "./BookLayout.vue?vue&type=script&lang=js&"
import style0 from "./BookLayout.vue?vue&type=style&index=0&id=e71cf960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71cf960",
  null
  
)

export default component.exports